import { SegmentService } from "@main-services/segment.service";
import { Injectable } from "@angular/core";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable({
	providedIn: "root"
})
export class CryptoDepositTrackingFacade {
	constructor(
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	public trackDepositNetworkListViewed(): void {
		this.segmentService.track({ name: "Deposit Crypto Network List Viewed" });
		this.rudderstackService.track({ name: "Deposit Crypto Network List Viewed" });
	}

	public trackDepositNetworkListClicked(network: string): void {
		this.segmentService.track({
			name: "Deposit Crypto Network List Item Clicked",
			properties: { network: network }
		});
		this.rudderstackService.track({
			name: "Deposit Crypto Network List Item Clicked",
			properties: { network: network }
		});
	}

	public trackOpenWarningScreen(): void {
		this.segmentService.track({ name: "How To Deposit Crypto Drawer Viewed" });
		this.rudderstackService.track({ name: "How To Deposit Crypto Drawer Viewed" });
	}

	public trackUnderstandButtonClicked(): void {
		this.segmentService.track({ name: "How To Deposit Crypto Drawer I Understand Button Clicked" });
		this.rudderstackService.track({ name: "How To Deposit Crypto Drawer I Understand Button Clicked" });
	}

	public trackDepositCryptoSummaryViewed(): void {
		this.segmentService.track({ name: "Deposit Crypto Summary Viewed" });
		this.rudderstackService.track({ name: "Deposit Crypto Summary Viewed" });
	}

	public trackViewDepositAddressClicked(): void {
		this.segmentService.track({ name: "View Deposit Address Clicked" });
		this.rudderstackService.track({ name: "View Deposit Address Clicked" });
	}

	public trackCryptoAddressCloseButtonClicked(): void {
		this.segmentService.track({ name: "Wallet Address Close Clicked" });
		this.rudderstackService.track({ name: "Wallet Address Close Clicked" });
	}

	public trackDepositFlowStarted(): void {
		this.segmentService.track({ name: "Deposit Crypto Flow Started" });
		this.rudderstackService.track({ name: "Deposit Crypto Flow Started" });
	}
}
